import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Tab as MuiTab } from '@mui/material';
// Note: the `value` will always be the index of the Tab
export function Tab({ sx, Icon, ...props }) {
    return /*#__PURE__*/ _jsx(MuiTab, {
        sx: sx,
        icon: Icon,
        ...props
    });
}

//# sourceMappingURL=Tab.js.map